import React from 'react'
import { PlusSquareIcon } from '@chakra-ui/icons'
import {
  Button,
  IconButton,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  ModalOverlay,
  ModalContent,
  ModalCloseButton
} from '@chakra-ui/react'

import { QuestionDataListGroup } from '../containers'

export const QuestionPickModal = ({ filter, exclude, onPick, onClose, ...props }) => {
  const handlePick = question => onPick(question)

  return (
    <Modal {...props} onClose={onClose} size='xl'>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Adicionar Questão</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <QuestionDataListGroup
            filter={filter}
            exclude={exclude}
            actions={question => (
              <IconButton
                height='100%'
                borderRadius='0'
                variant='ghost'
                colorScheme='green'
                aria-label='Adicionar'
                icon={<PlusSquareIcon />}
                onClick={() => handlePick(question)}
              />
            )}
          />
        </ModalBody>
        <ModalFooter>
          <Button onClick={onClose}>Fechar</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default QuestionPickModal
